import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { WaveWinnersLoading } from "./WaveWinnersLoading";
import { WaveWinnersEmpty } from "./WaveWinnersEmpty";
import { WaveWinnersPodiumContent } from "./WaveWinnersPodiumContent";
interface WaveWinnersPodiumProps {
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly winners: ApiWaveDecisionWinner[];
  readonly isLoading: boolean;
  readonly showVoteDetails?: boolean | undefined;
}
export const WaveWinnersPodium: React.FC<WaveWinnersPodiumProps> = t0 => {
  const $ = _c(8);
  const {
    onDropClick,
    winners,
    isLoading,
    showVoteDetails: t1
  } = t0;
  const showVoteDetails = t1 === undefined ? true : t1;
  const firstPlaceWinner = winners[0];
  const secondPlaceWinner = winners[1];
  const thirdPlaceWinner = winners[2];
  if (isLoading) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <WaveWinnersLoading />;
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    return t2;
  }
  if (!winners.length) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <WaveWinnersEmpty />;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  let t2;
  if ($[2] !== firstPlaceWinner || $[3] !== onDropClick || $[4] !== secondPlaceWinner || $[5] !== showVoteDetails || $[6] !== thirdPlaceWinner) {
    t2 = <WaveWinnersPodiumContent onDropClick={onDropClick} firstPlaceWinner={firstPlaceWinner} secondPlaceWinner={secondPlaceWinner} thirdPlaceWinner={thirdPlaceWinner} showVoteDetails={showVoteDetails} />;
    $[2] = firstPlaceWinner;
    $[3] = onDropClick;
    $[4] = secondPlaceWinner;
    $[5] = showVoteDetails;
    $[6] = thirdPlaceWinner;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};